import API_ENDPOINT from "../constants/api_endpoint.constant";
import axios from '../utils/axiosService';

export default class ReceiptMonthlyService {
    getData(merchantNo, invoiceNo) {
        return axios.get(`${API_ENDPOINT.INVOICE_RECEIPT}/receipt-monthly?merchantNo=${btoa(merchantNo)}&invoiceNo=${invoiceNo}`);
    };
}